/* eslint-disable */
const CONST = {
  ALL_FREQUENCIES: [
    {
      label: "Select One",
      value: 0
    },
    {
      label: "Daily",
      value: 2
    },
    {
      label: "Weekly",
      value: 3
    },
    {
      label: "Monthly",
      value: 4
    },
    {
      label: "Yearly",
      value: 5
    }
  ]
};

export default CONST;
